export default __webpack_public_path__ + "static/media/logo.b11b8498.svg";